/* Popup "Try your luck" (raspadinha) — sem app. Estado por navegador: fechado -> botão flutuante;
   concluído -> não volta. Aparece com 5 s de página (o gatilho da referência). */
(function () {
  var raiz = document.getElementById('nesti-rasp'); if (!raiz) return;
  var flut = document.getElementById('nesti-rasp-flutuante');
  var CH = 'nesti-raspadinha';
  function ler() { try { return JSON.parse(localStorage.getItem(CH) || '{}'); } catch (e) { return {}; } }
  function gravar(o) { try { localStorage.setItem(CH, JSON.stringify(o)); } catch (e) {} }
  function sessao(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  var est = ler();
  function etapa(n) { raiz.querySelectorAll('.nesti-rasp__etapa').forEach(function (e) { e.hidden = e.getAttribute('data-etapa') !== n; }); }
  // o foco vai para o diálogo inteiro (como no app): focar o X desenhava a moldura de foco do tema em volta dele
  function abrir() { raiz.hidden = false; if (flut) flut.hidden = true; document.documentElement.style.overflow = 'hidden'; pintar(); try { raiz.focus({ preventScroll: true }); } catch (e) {} }
  function fechar() {
    raiz.hidden = true; document.documentElement.style.overflow = '';
    var e = ler();
    if (e.estado !== 'concluido') { e.estado = 'fechado'; gravar(e); if (flut && sessao('nesti-rasp-flut') !== 'fora') flut.hidden = false; }
  }
  /* ---- raspadinha: camada dourada num canvas, apagada pelo dedo/mouse ---- */
  var cv = raiz.querySelector('.nesti-rasp__capa'), ctx = cv.getContext('2d'), pintado = false, raspado = false;
  function pintar() {
    if (pintado) return; pintado = true;
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () { ctx.globalCompositeOperation = 'source-over'; ctx.drawImage(img, 0, 0, cv.width, cv.height); };
    img.onerror = function () { var g = ctx.createLinearGradient(0, 0, cv.width, cv.height); g.addColorStop(0, '#e7c86a'); g.addColorStop(1, '#b8923a'); ctx.fillStyle = g; ctx.fillRect(0, 0, cv.width, cv.height); };
    img.src = raiz.getAttribute('data-capa');
  }
  function ponto(ev) {
    var r = cv.getBoundingClientRect(), t = ev.touches ? ev.touches[0] : ev;
    return { x: (t.clientX - r.left) * cv.width / r.width, y: (t.clientY - r.top) * cv.height / r.height };
  }
  // a regra do app da referência: pincel redondo de 20 px de raio, pontos a cada 40% do raio ao longo
  // do risco, e o prêmio libera quando 40% do cartão está raspado — conferido durante o risco
  var riscando = false, ult = null, PINCEL = 20, LIMITE = 0.4, conferindo = false;
  function circulo(x, y) { var esc = cv.width / cv.getBoundingClientRect().width; ctx.beginPath(); ctx.arc(x, y, PINCEL * esc, 0, Math.PI * 2); ctx.fill(); }
  function risca(p) {
    ctx.globalCompositeOperation = 'destination-out';
    var a = ult || p, dx = p.x - a.x, dy = p.y - a.y, dist = Math.hypot(dx, dy);
    var passo = Math.max(1, PINCEL * 0.4 * cv.width / cv.getBoundingClientRect().width), n = Math.max(1, Math.ceil(dist / passo));
    for (var k = 1; k <= n; k++) circulo(a.x + dx * k / n, a.y + dy * k / n);
    ult = p;
    conferir();
  }
  function conferir() {
    if (raspado || conferindo) return;
    conferindo = true;
    requestAnimationFrame(function () {
      conferindo = false;
      try {
        var d = ctx.getImageData(0, 0, cv.width, cv.height).data, vazios = 0, n = 0;
        for (var i = 3; i < d.length; i += 16) { n++; if (d[i] === 0) vazios++; }
        if (vazios / n >= LIMITE) revelar();
      } catch (e) { revelar(); }
    });
  }
  // raspou: a camada some e o botão Claim aparece (antes ele fica invisível, como no app)
  function revelar() { raspado = true; cv.style.transition = 'opacity 180ms ease'; cv.style.opacity = '0'; raiz.classList.add('is-raspado'); setTimeout(function () { cv.style.pointerEvents = 'none'; }, 400); }
  function ini(ev) { riscando = true; ult = null; risca(ponto(ev)); ev.preventDefault(); }
  function mov(ev) { if (!riscando) return; risca(ponto(ev)); ev.preventDefault(); }
  function fim() { if (!riscando) return; riscando = false; ult = null; conferir(); }
  cv.addEventListener('mousedown', ini); window.addEventListener('mousemove', mov); window.addEventListener('mouseup', fim);
  cv.addEventListener('touchstart', ini, { passive: false }); cv.addEventListener('touchmove', mov, { passive: false }); cv.addEventListener('touchend', fim);
  /* ---- etapas ---- */
  raiz.querySelector('[data-rasp-claim]').addEventListener('click', function () { revelar(); etapa('email'); var i = raiz.querySelector('input[type=email]'); if (i) setTimeout(function () { i.focus(); }, 300); });
  var form = raiz.querySelector('[data-rasp-form]');
  // inscrição na newsletter da loja pelo caminho normal do formulário de cliente da Shopify (ela
  // intercepta o envio — proteção contra robô — e recarrega a página). Antes de sair marca o envio;
  // na volta o popup reabre direto no prêmio (ou no e-mail, se a Shopify devolveu erro).
  if (form) form.addEventListener('submit', function () {
    var e = ler(); e.estado = 'enviando'; e.em = Date.now(); gravar(e);
  });
  raiz.querySelectorAll('[data-rasp-fechar]').forEach(function (b) { b.addEventListener('click', fechar); });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !raiz.hidden) fechar(); });
  if (flut) {
    flut.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-rasp-flutuante-fechar]')) { flut.hidden = true; sessao('nesti-rasp-flut', 'fora'); return; }
      etapa(raspado ? 'email' : 'raspar'); abrir();
    });
  }
  /* ---- gatilho ---- */
  if (est.estado === 'enviando') {
    var erro = raiz.querySelector('[data-rasp-erro]');
    if (erro && Date.now() - (est.em || 0) < 600000) { est.estado = ''; gravar(est); revelar(); etapa('email'); abrir(); return; }
    est.estado = 'concluido'; gravar(est); revelar(); etapa('fim'); abrir(); return;
  }
  if (est.estado === 'concluido') return;
  if (est.estado === 'fechado') { if (flut && sessao('nesti-rasp-flut') !== 'fora') flut.hidden = false; return; }
  var espera = Math.max(0, 5000 - (window.performance ? performance.now() : 0));
  setTimeout(function () { if (ler().estado) return; etapa('raspar'); abrir(); }, espera);
  window.NestiRaspadinha = { abrir: function () { etapa('raspar'); abrir(); }, fechar: fechar };
})();
